import React, { useState } from "react";
import PageNavLink, { PageNavLinkProps } from "./PageNavLink";
import RGL, { WidthProvider } from "react-grid-layout";
import styled from "styled-components";
import MovableIcon from "../../assets/icons/movable.svg2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import MyIcon from "./MyIcon";
import { pageProps } from "../helpers/pageProps";
import NewFeature from "../Builder/Components/NewFeature";

const { showNewFeatures } = pageProps;

const ReactGridLayout = WidthProvider(RGL);

const StyledItem = styled.div`
  .handle {
    opacity: 0;
  }
  &:hover .handle {
    opacity: 1;
  }
`;

export default function PageNavLinks({
  links,
  pageName,
}: {
  links: PageNavLinkProps[];
  pageName: string;
}) {
  const defaultLayout = links.map((link, index) => ({
    i: link.href,
    x: index,
    y: 0,
    w: 1,
    h: 1,
  }));

  const [layout, setLayout] = useState<any>(
    JSON.parse(localStorage.getItem(`${pageName}-layout`) || "null") ||
      defaultLayout
  );

  return (
    <div className="my-4 rounded-3 bg-loop position-relative">
      <button
        type="button"
        className="position-absolute end-0 btn z-1"
        title="Reset layout"
        onClick={() => setLayout(defaultLayout)}
      >
        <FontAwesomeIcon icon={faUndo} className="text-purple" />
      </button>
      <ReactGridLayout
        layout={layout}
        onLayoutChange={(l: any) => {
          setLayout(l);
          localStorage.setItem(`${pageName}-layout`, JSON.stringify(l));
        }}
        draggableHandle=".handle"
        rowHeight={62}
        cols={9}
        compactType="horizontal"
        maxRows={1}
        allowOverlap={false}
        isResizable={false}
        useCSSTransforms
      >
        {links.map((link) => (
          <StyledItem key={link.href}>
            <div
              className="handle position-absolute z-1 p-1"
              style={{ cursor: "grab", right: 20 }}
            >
              <MovableIcon width={15} />
            </div>
            {link.newFeature ? (
              <NewFeature showDisabled>
                <PageNavLink
                  Icon={link.Icon}
                  label={link.label}
                  href={link.href}
                  badge={link.badge}
                />
              </NewFeature>
            ) : (
              <PageNavLink
                Icon={link.Icon}
                label={link.label}
                href={link.href}
                badge={link.badge}
              />
            )}
          </StyledItem>
        ))}
      </ReactGridLayout>
    </div>
  );
}
